import http from "../http-common";

class UserService {
    login(data) {
        return http.post("/users/login", data);
    }
    logout(data) {
        return http.get("/users/logout", { params: data });
    }
    registration(data) {
        return http.post("/users/kids/parent/register", data, {
            headers: {
                'apiKey': ''
            }
        });
    }
    userDetail() {
        return http.get("/users/detail");
    }
    isUserLogin() {
        return http.get("/users/isUserLogin");
    }
    verifyEmail(data) {
        return http.post("/users/verify/email", data);
    }
    kidsLogin(data) {
        return http.post("/users/kids/parent/login", data, {
            headers: {
                'apiKey': ''
            }
        });
    }
    sendForgetPasswordLink(data) {
        return http.post("/users/send-forget-password-link", data);
    }
    resetPassword(data) {
        return http.post("/users/reset-password", data);
    }
    verifyOtp(data) {
        return http.post("/users/verify-otp", data);
    }
    verifyAppleLogin(data) {
        return http.post("/users/auth/apple", data);
    }
    fetchParentProfile() {
        return http.get("/users/parent/profile");
    }
    resendDelegatedAccessEmail(data) {
        return http.post("/users/parent/delegate-access-email", data);
    }
    saveDelegatedAccess(data) {
        return http.post("/users/parent/delegate-access", data);
    }
    updateDelegateAccessStatus(data) {
        return http.post("/users/parent/update-delegate-access/status", data);
    }
    getSubscriptionStatus() {
        return http.get("/users/subscription/status");
    }
    renewSubscription(data) {
        return http.post("/users/subscription/renew", data);
    }
    applyNextInvoiceDiscount(data) {
        return http.post("/users/subscription/apply-discount", data);
    }
}

export default new UserService();